import axios from 'axios';
import { clearSession, getSession, setSession } from '../utils/authStorage';

// Axios client used across the app.
export const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Public client for guest endpoints (no JWT interceptors).
export const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://127.0.0.1:8000',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Attach JWT access token automatically for authenticated endpoints.
api.interceptors.request.use((config) => {
  const session = getSession();
  const access = session?.access;
  if (access) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${access}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error?.config;
    const status = error?.response?.status;
    const isRefreshCall = originalRequest?.url?.includes('/api/auth/refresh/');

    if (status !== 401 || !originalRequest || originalRequest._retry || isRefreshCall) {
      return Promise.reject(error);
    }

    const session = getSession();
    const refresh = session?.refresh;
    if (!refresh) {
      clearSession();
      return Promise.reject(error);
    }

    originalRequest._retry = true;

    try {
      const { data } = await api.post('/api/auth/refresh/', { refresh });
      const newAccess = data?.access;
      if (!newAccess) {
        clearSession();
        return Promise.reject(error);
      }

      setSession({ access: newAccess });
      originalRequest.headers = originalRequest.headers || {};
      originalRequest.headers.Authorization = `Bearer ${newAccess}`;
      return api(originalRequest);
    } catch (refreshErr) {
      clearSession();
      return Promise.reject(refreshErr);
    }
  }
);

